export default __webpack_public_path__ + "static/media/double-tick-indicator.90d42204.svg";